(() => {
  if (window.otfCarouselEdges) return;
  const configurations = new WeakMap();
  const mediaSelectors = [
    '.otf-astra__media', '.card__inner', '.product__media', '.slideshow__media',
    '.otf-story-media', '.otf-visual-discovery__media', '.thumbnail',
    '.article-card__image-wrapper', '.collection-card__image', 'img'
  ];
  const visibleMedia = (track, items) => {
    const viewport = track.getBoundingClientRect();
    for (const selector of mediaSelectors) {
      const found = Array.from(track.querySelectorAll(selector)).find(element => {
        const rect = element.getBoundingClientRect();
        return rect.width > 0 && rect.height > 0 && rect.right > viewport.left + 1 && rect.left < viewport.right - 1;
      });
      if (found) return found;
    }
    // Text-only testimonials/columns have no image plane. Their visible content
    // is the functional exception; never silently remove overflowing navigation.
    return items.find(element => {
      const rect = element.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && rect.right > viewport.left + 1 && rect.left < viewport.right - 1;
    }) || null;
  };
  function button(element, direction) {
    if (!element) return;
    element.dataset.otfEdgeButton = direction;
    if (!element.querySelector('[data-otf-edge-icon]')) {
      const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      icon.dataset.otfEdgeIcon = '';
      icon.setAttribute('viewBox', '0 0 24 24');
      icon.setAttribute('aria-hidden', 'true');
      icon.setAttribute('focusable', 'false');
      const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', direction === 'previous' ? 'm14 5-7 7 7 7' : 'm10 5 7 7-7 7');
      icon.append(path);
      element.append(icon);
    }
  }
  function sync(host, track, options) {
    if (!host || !track || !options.previous || !options.next) return false;
    configurations.set(host, { track, options });
    host.dataset.otfEdgeHost = '';
    const { previous, next, controls } = options;
    button(previous, 'previous'); button(next, 'next');
    let arrowsOnly = false;
    if (controls) {
      arrowsOnly = Array.from(controls.children).every(child => child === previous || child === next
        || child.matches('.visually-hidden, [aria-live]'));
      controls.dataset.otfEdgeControls = arrowsOnly ? 'arrows' : 'mixed';
      for (let parent = controls.parentElement; parent && parent !== host && host.contains(parent); parent = parent.parentElement) {
        parent.dataset.otfEdgeStatic = '';
      }
    }
    const items = options.items || Array.from(track.children);
    const bounds = track.getBoundingClientRect();
    const media = visibleMedia(track, items);
    const available = track.clientWidth > 0 && bounds.height > 0 && items.length > 1
      && track.scrollWidth > track.clientWidth + 2 && Boolean(media);
    if (!available && (document.activeElement === previous || document.activeElement === next)) {
      // A breakpoint can remove overflow while an arrow owns focus. Keep that
      // focus in its own rail, without adding a new sequential tab stop.
      if (!track.hasAttribute('tabindex')) track.setAttribute('tabindex', '-1');
      track.focus({ preventScroll: true });
    }
    // Counters, live regions, dots and playback controls retain their own layout
    // and visibility. Only a dedicated pair-of-arrows wrapper is collapsed.
    if (controls && arrowsOnly) controls.hidden = !available;
    previous.hidden = next.hidden = !available;
    host.dataset.otfEdgeOverflow = String(available);
    if (available) {
      const origin = host.getBoundingClientRect();
      const image = media.getBoundingClientRect();
      host.style.setProperty('--otf-edge-y', `${image.top + image.height / 2 - origin.top}px`);
      host.style.setProperty('--otf-edge-left', `${Math.max(0, bounds.left - origin.left)}px`);
      host.style.setProperty('--otf-edge-right', `${Math.max(0, origin.right - bounds.right)}px`);
    }
    return available;
  }
  window.otfCarouselEdges = { sync };
  // Image completion can change the media plane without changing track width.
  document.addEventListener('load', event => {
    const host = event.target.closest?.('[data-otf-edge-host]');
    const configuration = host && configurations.get(host);
    if (configuration) sync(host, configuration.track, configuration.options);
  }, true);
})();
